import { FC } from 'react'
import Toast from './components/popups/Toaster'
import Footer from './components/Footer'
import Routes from './Routes/Routes'
import Header from './components/Header/Header'
import { AuthProvider } from './layouts/AuthContext'

const App: FC = () => (
  <AuthProvider>
    <Toast />
    <Header />
    <Routes />
    <Footer />
  </AuthProvider>
)

export default App
